<template>
    <div class="tg-restaurants" v-if="cur_item">

        <b-overlay :show="is_load" rounded="sm">

            <b-tabs pills card vertical v-if="organizations.length">
                <b-tab
                    v-for="(organization, index) in organizations"
                    :key="'org_' + organization.id"
                    :active="index === 0"
                    @click="selectOrganization(organization)"
                >
                    <template #title>
                        {{ organization.title || organization.name }}
                        <b-spinner
                            small
                            type="grow"
                            v-if="loading_org_id === organization.id">
                        </b-spinner>
                    </template>

                    <div v-if="getRestaurantsByOrganization(organization.id).length">

                        <div
                            v-for="restaurant in getRestaurantsByOrganization(organization.id)"
                            :key="'rest_' + restaurant.id"
                            class="list-group-item d-flex align-items-center justify-content-between"
                        >
                            <div>
                                <div class="fw-600">
                                    {{ restaurant.title || restaurant.name }}
                                </div>

                                <small class="text-muted">
                                    ID: {{ restaurant.id }}
                                </small>
                            </div>

                            <div class="custom-control custom-switch">
                                <input
                                    :id="'tg-rest-' + restaurant.id"
                                    type="checkbox"
                                    class="custom-control-input"
                                    :checked="isRestaurantEnabled(restaurant.id)"
                                    @change="toggleRestaurant(restaurant, $event.target.checked)"
                                >

                                <label
                                    class="custom-control-label"
                                    :for="'tg-rest-' + restaurant.id">
                                </label>
                            </div>
                        </div>

                    </div>

                    <div v-else class="text-muted p-3">
                        {{ __t('NO_DATA') }}
                    </div>

                </b-tab>
            </b-tabs>

            <div v-else class="text-muted p-3">
                {{ __t('NO_DATA') }}
            </div>

        </b-overlay>

    </div>
</template>

<script>
export default {
    name: "tg_restaurants",

    props: {
        role_item: {
            type: Object
        }
    },

    data() {
        return {
            cur_item: {
                attached_restaurants: []
            },

            organizations: [],
            restaurants_by_org: {},

            is_load: false,
            loading_org_id: 0,
        }
    },

    created() {
        this.cur_item = this.role_item || {
            attached_restaurants: []
        };

        if (!this.cur_item.attached_restaurants) {
            this.$set(this.cur_item, 'attached_restaurants', []);
        }

        this.load_organizations();
    },

    computed: {
        attachedRestaurantIds() {
            return (this.cur_item?.attached_restaurants || [])
                .map(item => parseInt(item.rest_id));
        },
    },

    methods: {
        async load_organizations() {
            this.organizations = [];
            this.is_load = true;

            await api.post('/internal/v1/catalog/organizations')
                .then(({data}) => {
                    this.is_load = false;

                    if (data.status === "operation_success") {
                        this.organizations = data.data || [];

                        this.organizations = this.organizations.map(item => {
                            item.is_active = false;
                            return item;
                        });

                        if (this.organizations.length) {
                            this.selectOrganization(this.organizations[0]);
                        }
                    } else {
                        this.organizations = [];
                    }
                })
                .catch(({response}) => {
                    this.is_load = false;
                    this.organizations = [];

                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status
                    });
                });
        },

        async selectOrganization(organization) {
            if (!organization || !organization.id) {
                return;
            }

            this.organizations = this.organizations.map(item => {
                item.is_active = parseInt(item.id) === parseInt(organization.id);
                return item;
            });

            if (this.restaurants_by_org[organization.id]) {
                return;
            }

            await this.load_restaurants(organization.id);
        },

        async load_restaurants(organization_id) {
            this.loading_org_id = organization_id;

            await api.post('/internal/v1/catalog/restaurants', {
                filter: {
                    organizations: [organization_id]
                },
                list: {
                    limit: 200
                }
            }).then(({data}) => {
                this.loading_org_id = 0;

                if (data.status === "operation_success") {
                    this.$set(this.restaurants_by_org, organization_id, data.data || []);
                } else {
                    this.$set(this.restaurants_by_org, organization_id, []);
                }
            }).catch(({response}) => {
                this.loading_org_id = 0;

                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            });
        },

        getRestaurantsByOrganization(organization_id) {
            return this.restaurants_by_org[organization_id] || [];
        },

        isRestaurantEnabled(rest_id) {
            return this.attachedRestaurantIds.includes(parseInt(rest_id));
        },

        toggleRestaurant(restaurant, checked) {
            let restId = parseInt(restaurant.id);
            let attached = this.cur_item.attached_restaurants || [];

            if (checked) {
                let exists = attached.some(item => parseInt(item.rest_id) === restId);

                if (!exists) {
                    attached.push({
                        id: 0,
                        user_uid: this.cur_item.user_uid,
                        rest_id: restId,
                        client_id: this.cur_item.client_id
                    });
                }
            } else {
                attached = attached.filter(item => parseInt(item.rest_id) !== restId);
            }

            this.$set(this.cur_item, 'attached_restaurants', attached);

            this.$emit('on_change_attribute', 'attached_restaurants', attached);
        },
    }
}
</script>

<style scoped>
.list-group-item {
    border-left: 0;
    border-right: 0;
}

.fw-600 {
    font-weight: 600;
}
</style>
